"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
class Feature {
    enabledRules;
    constructor(enabledRules) {
        this.enabledRules = new Set(enabledRules);
    }
    isEnabled(rule) {
        return this.enabledRules.has(rule);
    }
}
exports.Feature = Feature;
